<se-fe-page
  [seFeDataLoaded]="true"
  class="app-suggested-address"
  [ngClass]="{routedFlow: routedFlow}">
  <div seFePageContent>
    <section class="app-suggested-address">
      <se-fe-header seFeDataTitle="Address"></se-fe-header>
      <p class="app-suggested-address__text">
        @if (mustUseSuggestedAddress) {
          Hmm, we couldn't verify your address as entered, but we found a close
          match.
        } @else {
          Please choose which address to use or enter a different one.
        }
      </p>
      @if (ready) {
        <form
          [formGroup]="suggestedAddressForm"
          class="app-suggested-address__form"
          aria-labelledby="rdoBtns">
          <mat-radio-group
            aria-label="Select an option"
            class="radio-group"
            id="rdoBtns"
            role="radiogroup"
            aria-required="true"
            formControlName="useSuggested"
            required="true"
            [ngClass]="{'radio-group--invalid': formHasErrors()}">
            <mat-radio-button
              id="rdo_yes"
              [value]="true"
              class="radio-label"
              disableRipple="true">
              <div
                class="address-radio"
                *ngrxLet="suggestedAddress$ as suggestedAddress">
                @if (suggestedAddress) {
                  <div>
                    <span class="radio-title app-suggested-address__text">
                      Use suggested address
                    </span>
                    <span class="address-line1 app-suggested-address__text">
                      {{ suggestedAddress.address1 }},
                      {{ suggestedAddress.address2 }}
                    </span>
                    <span class="address-line2 app-suggested-address__text">
                      {{ suggestedAddress.city }}, {{ suggestedAddress.state }}
                      {{ suggestedAddress.zip }}
                    </span>
                  </div>
                }
              </div>
            </mat-radio-button>
            @if (!mustUseSuggestedAddress) {
              <mat-radio-button
                id="rdo_no"
                [value]="false"
                class="radio-label"
                disableRipple="true">
                <div
                  class="address-radio"
                  *ngrxLet="originalAddress$ as originalAddress">
                  @if (originalAddress) {
                    <div>
                      <span class="radio-title app-suggested-address__text">
                        Use original address
                      </span>
                      <span class="address-line1 app-suggested-address__text">
                        {{ originalAddress.address1 }},
                        {{ originalAddress.address2 }}
                      </span>
                      <span class="address-line2 app-suggested-address__text">
                        {{ originalAddress.city }}, {{ originalAddress.state }}
                        {{ originalAddress.zip }}
                      </span>
                    </div>
                  }
                </div>
              </mat-radio-button>
            }
            <span
              class="radio-group-error-message form-control__error-message app-suggested-address__text"
              #radioErrorMessage
              tabindex="-1">
              Choose an option to proceed.
            </span>
          </mat-radio-group>
        </form>
      }
    </section>
    <se-fe-footer>
      <se-fe-button
        seFeDataEmphasis="high"
        [seFeDataFullWidth]="(breakpointUtils.smallScreen$ | async) ?? false"
        [seFeDataIsDisabled]="!suggestedAddressForm.valid"
        (click)="continueToCheckout()">
        Continue to Checkout
      </se-fe-button>
    </se-fe-footer>
  </div>
</se-fe-page>
